import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'

import StatusMessage from 'components/StatusMessage'
import VehicleProfileShareLogic from 'components/Vehicles/VehicleProfile/VehicleProfileShare/VehicleProfileShareLogic'
import Switch from '@material-ui/core/Switch'

import './vehicle-profile-share-toggle.pcss'

const VehicleProfileShareToggle = ({ t, isActive, linkId }) => {
    const handleChange = async (e, vehicleProfileShareLogic) => {
        await vehicleProfileShareLogic.activateVehicleSharing(linkId, e.target.checked)
    }

    return (
        <VehicleProfileShareLogic>
            {(vehicleProfileShareLogic) => (
                <StatusMessage
                    type="alert"
                    color="primary"
                    cssClass={classNames('vehicle-profile-share-toggle', {
                        'vehicle-profile-share-toggle--loading': vehicleProfileShareLogic.loading,
                    })}
                >
                    <div>
                        <strong>{!isActive && t('vehicleProfile:share.toggle.inactiveTitle')}</strong>
                        <p>
                            {isActive
                                ? t('vehicleProfile:share.toggle.active')
                                : t('vehicleProfile:share.toggle.inactive')}
                        </p>
                    </div>
                    <div>
                        <Switch
                            checked={isActive}
                            onChange={(e) => handleChange(e, vehicleProfileShareLogic)}
                            color="default"
                            inputProps={{ 'aria-label': 'checkbox with default color' }}
                        />
                    </div>
                </StatusMessage>
            )}
        </VehicleProfileShareLogic>
    )
}

VehicleProfileShareToggle.propTypes = {
    linkId: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
}

export default withTranslationCustom('vehicleProfile')(React.memo(VehicleProfileShareToggle))
